// apiActions.js
export const search = (text, adultContent) => {
	let params = new URLSearchParams();
	if (text) {
		params.append('q', text);
	}
	if (adultContent) {
		params.append('degen', adultContent);
	}
	return {
		type: 'API_CALL',
		meta: {
			url: '/api/posts/search',
			method: 'GET',
			query: params.toString() ? params.toString() : '',
			onSuccess: 'SEARCH_SUCCESS',
			authOptional: true,
		},
	};
};

export const toggleFavorite = (item, favorite) => ({
	type: 'API_CALL',
	meta: {
		url: `/api/favorites/${item.url}`,
		method: 'POST',
		body: JSON.stringify({ favorite }),
		onSuccess: 'TOGGLE_FAVORITE_SUCCESS',
		authRequired: true,
	},
});

export const fetchProfileTab = (tab, username, nextPage) => {
	let params = new URLSearchParams();
	if (username) {
		params.append('username', username);
	}
	if (nextPage) {
		params.append('nextPage', nextPage);
	}
	return {
		type: 'API_CALL',
		meta: {
			url: `/api/profile/tab/${tab}`,
			query: params.toString() ? params.toString() : '',
			method: 'GET',
			onSuccess: 'FETCH_PROFILE_TAB_SUCCESS',
			authOptional: true,
		},
	}
};

export const fetchProfile = (user_id) => ({
	type: 'API_CALL',
	meta: {
		url: `/api/profile/username/${user_id}`,
		method: 'GET',
		onSuccess: 'FETCH_PROFILE_SUCCESS',
		onError: 'FETCH_PROFILE_FAILURE',
		authOptional: true,
	},
});

export const updateSettings = (settings) => ({
	type: 'API_CALL',
	meta: {
		url: '/api/settings/update',
		method: 'POST',
		body: JSON.stringify(settings),
		onSuccess: 'UPDATE_SETTINGS_SUCCESS',
		onError: 'UPDATE_SETTINGS_FAILURE',
		authRequired: true,
	},
});

export const commentReaction = (comment, type, value) => ({
	type: 'API_CALL',
	meta: {
		url: `/api/comments/${comment.id}/${type}`,
		method: 'POST',
		body: JSON.stringify(type === 'upvote' ? { upvoted: value } : { downvoted: value }),
		onSuccess: 'COMMENT_REACTION_SUCCESS',
		authRequired: true,
	},
});

export const uploadProfilePicture = (file) => ({
	type: 'API_CALL',
	meta: {
		url: '/api/upload/profile-picture',
		method: 'POST',
		onSuccess: 'UPLOAD_PROFILE_PICTURE_SUCCESS',
		fileUpload: true,
		body: file,
		authRequired: true,
	},
});

export const uploadImage = (file) => ({
	type: 'API_CALL',
	meta: {
		url: '/api/upload',
		method: 'POST',
		onSuccess: 'UPLOAD_IMAGE_SUCCESS',
		fileUpload: true,
		body: file,
		authRequired: true,
	},
});

export const postComment = (post_url, comment_id, comment, uploadedImage) => ({
	type: 'API_CALL',
	meta: {
		url: `/api/comments`,
		method: 'POST',
		onSuccess: 'POST_COMMENT_SUCCESS',
		body: JSON.stringify({ 
			comment: comment, 
			post_url: post_url,
			parent_id: comment_id,
			uploadedImage: uploadedImage
		}),
		authRequired: true,
	},
});

export const fetchComments = (post_url, comment_id, order) => {
	let params = new URLSearchParams();
	if (comment_id) {
		params.append('parent_id', comment_id);
	}
	if (order) {
		params.append('order', order);
	}
	return {
		type: 'API_CALL',
		meta: {
			url: `/api/comments/${post_url}`,
			method: 'GET',
			query: params.toString() ? params.toString() : '',
			onSuccess: 'FETCH_COMMENTS_SUCCESS',
			authOptional: true,
		},
	};
};

export const createPost = (post) => ({
	type: 'API_CALL',
	meta: {
		url: '/api/posts',
		method: 'POST',
		onSuccess: 'CREATE_POST_SUCCESS',
		onError: 'CREATE_POST_FAILURE',
		body: JSON.stringify(post),
		authRequired: true,
	},
});

export const createReaction = (reaction) => ({
	type: 'API_CALL',
	meta: {
		url: `/api/reactions/${reaction.url}/${reaction.type}`,
		method: 'POST',
		onSuccess: 'CREATE_REACTION_SUCCESS',
		body: JSON.stringify(reaction),
		authRequired: true,
	},
});

export const fetchImages = () => ({
	type: 'API_CALL',
	meta: {
		url: '/api/upload/images',
		method: 'GET',
		onSuccess: 'FETCH_IMAGES_SUCCESS',
		authRequired: true,
	},
});

export const fetchProfileData = () => ({
	type: 'API_CALL',
	meta: {
		url: '/api/users/profile',
		method: 'GET',
		onSuccess: 'FETCH_PROFILE_DATA_SUCCESS',
		authRequired: true,
	},
});

export const fetchPosts = (query) => ({
	type: 'API_CALL',
	meta: {
		url: '/api/posts',
		method: 'GET',
		onSuccess: 'FETCH_DATA_SUCCESS',
		query,
		authOptional: true,
	},
});

export const fetchPost = (post_id) => ({
	type: 'API_CALL',
	meta: {
		url: `/api/posts/${post_id}`,
		method: 'GET',
		onError: 'FETCH_POST_FAILURE',
		onSuccess: 'FETCH_POST_SUCCESS',
		authOptional: true,
	},
});
  
export const fetchTags = (category, selected, adultContent) => {
	let params = new URLSearchParams();
	if (selected === "tag") {
		params.append('tag', category);
	}
	else if (category) {
		params.append('category', category);
	}
	if (adultContent) {
		params.append('degen', adultContent);
	}
	return {
		type: 'API_CALL',
		meta: {
			url: `/api/posts/tags`,
			query: params.toString() ? params.toString() : '',
			method: 'GET',
			// onStart: 'FETCH_TAGS_REQUEST',
			// onError: 'FETCH_TAGS_FAILURE',
			onSuccess: 'FETCH_TAGS_SUCCESS',
			authRequired: false,
		},
	};
};